// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"d3350a45","238":"c630a9bc","239":"c5890ec9","453":"e47f8878","455":"eb10fb47","977":"2012ca7f"}[chunkId] + ".chunk.js";
};